import React from "react";
import { hasNumber, perThousand } from "../constants";
import { useImageAnalysisSettings } from "../ImageAnalysisSettings";

// "Which model reads the next photograph" - one control, rendered in both places that start an analysis:
// the run bar above the grid, and the viewer's AI Analyze tab next to "Re-analyse this image".
//
// ONE SETTING, not two. Both read and write the page's settings context, so the tab opens on whatever the
// bar is set to and a change in either is what the other shows. The alternative - a private selection inside
// the viewer - reads fine until the two disagree, and then the page is telling the user two different things
// about what the next click will cost. ("Analyse Selected" and "Analyse All" still name the model in their
// confirmation before anything is spent, which is what keeps a one-photo experiment from quietly becoming a
// 20,000-photo run on the same model.)
//
// Hidden when there is nothing to choose between - one model configured, or the models request failed and
// the backend's own default is what every call will use anyway.

function ModelPicker({ disabled = false, className = "" }) {
    const { model, setModel, models, showPricing } = useImageAnalysisSettings();
    if (!models || models.length < 2) return null;

    return (
        <label className={`ia-model-pick ${className}`.trim()}>
            <span>Model</span>
            <select
                className="form-control form-control-sm"
                value={model || ""}
                disabled={disabled}
                onChange={e => setModel(e.target.value)}
            >
                {models.map(m => (
                    <option key={m.id} value={m.id}>
                        {m.label}
                        {showPricing && hasNumber(m.cost_per_image) ? ` (${perThousand(m.cost_per_image)})` : ""}
                    </option>
                ))}
            </select>
        </label>
    );
}

export default ModelPicker;
